/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Navbar , Form , Button , Card , Row , Col , Nav , NavDropdown} from 'react-bootstrap'
import {Lessons , SongsStories , SectionMenu , FavoriteButton} from '../components';
import Timeline from '../components/timeline.js';
import {Members , Live} from '../components/classes';
import Vocabulary from '../components/custom_content/vocabulary.js'




export default class Library extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab:this.props.match.params.tab,
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(props){

    }

    onNavigationSelect(eventKey){
        window.location.hash = "library/"+eventKey;
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.setState({
            tab:this.props.match.params.tab,
        })
    }

    getBody(){

        switch(this.state.tab)
        {
            case "vocabulary" : return <Vocabulary/>
            default: return null;
        }

    }

    render(){

        return <div>
                    <Row>
                        <Col md={12}>

                                <Vocabulary/>
                        </Col>
                    </Row>
                </div>


    }

}